<template>
  <div>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'default-layout',
  };
</script>

<style lang="scss" scoped>

</style>
